var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBritishFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    fill: "none",
    id: "e",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H25V20H0V0Z",
    fill: "#012169"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.92969 0L12.4609 7.54167L21.9531 0H25V2.58333L15.625 10.0417L25 17.4583V20H21.875L12.5 12.5417L3.16406 20H0V17.5L9.33594 10.0833L0 2.66667V0H2.92969Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5625 11.7083L25 18.3333V20L14.4141 11.7083H16.5625ZM9.375 12.5417L9.60938 14L2.10938 20H0L9.375 12.5417ZM25 0V0.125L15.2734 7.95833L15.3516 6.125L23.0469 0H25ZM0 0L9.33594 7.33333H6.99219L0 1.75V0Z",
    fill: "#C8102E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.41406 0V20H15.6641V0H9.41406ZM0 6.66667V13.3333H25V6.66667H0Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.04167V12.0417H25V8.04167H0ZM10.6641 0V20H14.4141V0H10.6641Z",
    fill: "#C8102E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBritishFlag);
export default __webpack_public_path__ + "static/media/BritishFlag.48360b311ede93ab11f2c0b408db212f.svg";
export { ForwardRef as ReactComponent };